import React from "react";
import { connect } from "react-redux";
import * as agent from "../agent";
import { reduxForm, Field } from "redux-form";
import { Masks } from "../constants/enums";
import { required, formatPhone, validatePhone } from "../utility";
import { DUPLICATE_CLIENT } from "../constants/actionTypes";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import SubmitButton from './SubmitButton';
import InnerLink from './InnerLink';
import Button from '@material-ui/core/Button';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PrimaryDivider from './PrimaryDivider';

const editClientForm = ({client, editClient, handleSubmit}) => {
    return (
        <form className="common-form wide-column" onSubmit={handleSubmit(data => editClient(client._id, data))} >
            <Field name="firstname"
                   component={MaterialTextField}
                   validate={required}
                   label="Имя" />
            <Field name="secondname"
                   component={MaterialTextField}
                   validate={required}
                   label="Фамилия" />
            <Field name="thirdname"
                   component={MaterialTextField}
                   validate={required}
                   label="Отчество" />
            <Field name="birthDate"
                   component={MaterialMaskedTextField}
                   validate={required}
                   mask={Masks.date}
                   label="Дата рождения" />
            <Field name="phone"
                   component={MaterialMaskedTextField}
                   mask={Masks.phone}
                   format={formatPhone}
                   validate={validatePhone}
                   placeholder="+7 (___) ___-__-__"
                   label="Номер телефона" />
            <Field name="passport.serie"
                   component={MaterialMaskedTextField}
                   mask={Masks.passportSerie}
                   label="Серия паспорта" />
            <Field name="passport.number"
                   component={MaterialMaskedTextField}
                   mask={Masks.passportNumber}
                   label="Номер паспорта" />
            <SubmitButton label="Сохранить" />
        </form>
    );
}

const EditClientForm = connect(
    (state, props) => {
        const { client } = props;
        return {
            enableReinitialize: true,
            initialValues: client,
        };
    }
)(reduxForm({
    form: "edit-client-form",
})(editClientForm));

class EditClient extends React.Component {

    state = {
        client: {}
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        const { clientId } = this.props;
        agent.Client.get(clientId)
            .then(res => this.setState({ client: res.client }))
            .catch(e => alert(e.message));
    }

    editClient = (id, data) => {
        agent.Clients.editClient(id, data)
            .then(res => this.setState({ client: res.client }))
            .then(() => alert("Данные успешно сохранены"))
            .catch(e => alert(e.message));
    }
    render() {
        const { userPermissions, onArchiveClient } = this.props;
        const { client = {} } = this.state;
        const { cars = [] } = client;

        return (
            <Fade in={true}>
                <React.Fragment>
                    <Typography variant="h4">Редактировать клиента</Typography>
                    <PrimaryDivider />
                    <Grid container justify="flex-start">
                        <Grid item>
                            <Paper className="common-paper padded-paper">
                                <EditClientForm client={client} editClient={this.editClient} />
                                <Typography variant="h5" gutterBottom>Заявки:</Typography>
                                {cars.map((car, i) => (
                                    <div key={i}>
                                        <InnerLink  href={`/client/${client._id}/editcar/${car._id}`} label={`Заявка №${car.number_id}: ${car.brand} ${car.model}`} />
                                    </div>
                                ))}
                                {userPermissions.includes("client-comment-delete") &&
                                    <Button type="submit"
                                            size="large"
                                            fullWidth
                                            onClick={() => onArchiveClient(client._id)}
                                            variant="contained">Отправить в архив</Button>
                                }
                            </Paper>
                        </Grid>
                    </Grid>
                </React.Fragment>
            </Fade>
        );
    }
}

const mapStateToProps = (state, {match}) => ({
    userPermissions: state.common.user.permissions,
    clientId: match.params.clientId,
});

const mapDispatchToProps = (dispatch, {match}) => ({
    onArchiveClient: (clientId) => {
        if(window.confirm("Вы уверены?")) {
            agent.Clients.archiveClient(clientId)
            .then(() => alert("Заявка перемещена в архив"))
            .then(() => dispatch({ type: DUPLICATE_CLIENT }))
        }
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(EditClient);



// WEBPACK FOOTER //
// ./src/components/EditClient.js